<template>
    <div class="custom-control custom-radio">
        <input type="radio" :name="$parent.name" :id="_uid" class="custom-control-input" @change="$emit('change')" @input="onInput" :checked="checked">
        <label class="custom-control-label" :for="_uid"><slot>{{ label }}</slot></label>
    </div>
</template>

<script>
export default {
    props: ['label', 'value'],
    computed: {
        checked: function() {
            return this.$parent.value == this.value;
        }
    },
    methods: {
        onInput: function(e) {
            this.$parent.$emit('input', this.value);
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-radio {
    &.custom-radio-lg {
        label {
            height: 30px;
            padding-right: 12px;
        }
    }
}
</style>